import { render, staticRenderFns } from "./RegisterInfoHongkong.vue?vue&type=template&id=66da16c2"
import script from "./RegisterInfoHongkong.vue?vue&type=script&lang=js"
export * from "./RegisterInfoHongkong.vue?vue&type=script&lang=js"
import style0 from "./RegisterInfoHongkong.vue?vue&type=style&index=0&id=66da16c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports